import { render, staticRenderFns } from "./AddonSubscriptions.vue?vue&type=template&id=4477fde3&scoped=true"
import script from "./AddonSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddonSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./AddonSubscriptions.vue?vue&type=style&index=0&id=4477fde3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477fde3",
  null
  
)

export default component.exports